/* bt-socd-designer.js — уся логіка блока blocks/set-option-cards-v2-designer.liquid
   (картки наборів + попап «Зробить дизайнер» + кошик).
   Винесено з блока 21.09.2026: Shopify обмежує Liquid-файл 256 КБ, а блок виріс
   до 293 КБ і перестав пушитись (FILE_VALIDATION_ERROR) — на PL це зробили раніше,
   тут той самий підхід. Код той самий, що був inline: `{{ uid }}` став UID,
   `{{ dsg_layout | json }}` — CFG.layout. Блок кладе [uid, cfg] у window.BtSocdQueue
   і підключає цей асет з defer; черга розбирається тут (порядок defer = порядок у
   документі, тож assets/bt-design-request.js уже визначений). Другий екземпляр блока
   на сторінці додає ще одну пару в чергу; повторне підключення асету — no-op. */
(function () {
  if (window.BtSocdInit) return;
  function init(UID, CFG) {
    CFG = CFG || {};

  (function() {
    var roots = document.querySelectorAll('.soc2-' + UID + '');
    if (!roots.length) return;
    var root = roots[roots.length - 1];

    var cards = root.querySelectorAll('.soc2__card-' + UID + '');
    var ctaBtn = root.querySelector('[data-soc2-cta]');

    // Build the CTA href by appending ?qty=N (or &qty=N if the URL already has params)
    // to the configured base URL. This lets the merchant set a base URL like
    // "/products/figure" and we automatically pass which option the user selected.
    function updateCtaHref(qty) {
      if (!ctaBtn) return;
      var base = ctaBtn.getAttribute('data-soc2-base-url') || '';
      var param = ctaBtn.getAttribute('data-soc2-qty-param') || 'qty';
      if (!base || base === '#') {
        // No base URL configured — nothing to update
        return;
      }

      // Strip any existing instance of the qty param so we don't accumulate duplicates
      var url = base;
      var qtyRegex = new RegExp('([?&])' + param + '=[^&]*');
      url = url.replace(qtyRegex, function (m, prefix) {
        // Drop this param entirely; we'll re-append below
        return prefix === '?' ? '?' : '';
      });
      // Clean up trailing/leading separators left behind
      url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');

      var separator = url.indexOf('?') === -1 ? '?' : '&';
      ctaBtn.setAttribute('href', url + separator + param + '=' + encodeURIComponent(qty));
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      // Update CTA href with the selected card's qty value (data-soc2-card="1" / "2" / "3")
      updateCtaHref(card.getAttribute('data-soc2-card'));
    }

    // Initialise href for the default-selected card (so refreshing the page keeps qty in URL)
    var initiallySelected = root.querySelector('.soc2__card-' + UID + '.is-selected');
    if (initiallySelected) {
      updateCtaHref(initiallySelected.getAttribute('data-soc2-card'));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-soc2-why], [data-soc2-trigger-global]')) return;
        if (card.tagName === 'A' && !card.classList.contains('is-selected')) {
          e.preventDefault();
          selectCard(card);
        } else {
          selectCard(card);
        }
      });
      card.addEventListener('keydown', function (e) {
        if (e.target.closest('[data-soc2-why], [data-soc2-trigger-global]')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (card.tagName === 'A' && card.classList.contains('is-selected')) {
            window.location = card.getAttribute('href');
          } else {
            selectCard(card);
          }
        }
      });
    });

    /* Cache one fetch per API URL to avoid hitting the endpoint on every popover open */
    var __soc2ApiCache = {};
    function fetchPricesOnce(url) {
      if (!url) return Promise.resolve(null);
      if (__soc2ApiCache[url]) return __soc2ApiCache[url];
      __soc2ApiCache[url] = fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return __soc2ApiCache[url];
    }

    /* Figurine-relevant add-on keys from /prices/ua. Frame-only keys
       (frame13x18, figureInFrame, animal, baby, animalCustomPaint) are
       intentionally excluded — this block is for figurine sets. */
    var FIG_ADDON_KEYS = [
      'photoFrontPrint',
      'photoFace',
      'customFrontPrint',
      'customBackPrint',
      'customHairColor',
      'accessory',
      'carabiner'
    ];

    /* Local-first label dictionary — the prices API sometimes returns
       English descriptions regardless of the endpoint locale, leaving
       the user with the wrong language in the popup. We keep canonical
       translations here and prefer them over `descs[k]`. The API desc
       is only a fallback for keys we haven't translated yet. */
    var SOC2_ADDON_LABELS = {
      uk: {
        photoFrontPrint:   'Принт торса з фото',
        photoFace:         'Обличчя з фото',
        customFrontPrint:  'Кастомний принт спереду',
        customBackPrint:   'Кастомний принт ззаду',
        customHairColor:   'Кастомний колір волосся',
        accessory:         'Аксесуар (руки, шия, талія)',
        carabiner:         'Карабін'
      },
      pl: {
        photoFrontPrint:   'Nadruk torsu ze zdjęcia',
        photoFace:         'Twarz ze zdjęcia',
        customFrontPrint:  'Niestandardowy nadruk z przodu',
        customBackPrint:   'Niestandardowy nadruk z tyłu',
        customHairColor:   'Niestandardowy kolor włosów',
        accessory:         'Akcesorium (ręce, szyja, biodra)',
        carabiner:         'Karabińczyk'
      },
      en: {
        photoFrontPrint:   'Torso print from photo',
        photoFace:         'Custom face from photo',
        customFrontPrint:  'Custom front print',
        customBackPrint:   'Custom back print',
        customHairColor:   'Custom hair color',
        accessory:         'Accessory (hands, neck, hips)',
        carabiner:         'Carabiner'
      }
    };
    function soc2DetectLang() {
      var html = document.documentElement;
      var l = (html && html.lang || '').slice(0, 2).toLowerCase();
      if (SOC2_ADDON_LABELS[l]) return l;
      var p = window.location.pathname || '';
      if (p.indexOf('/uk/') !== -1 || p === '/uk') return 'uk';
      if (p.indexOf('/en/') !== -1 || p === '/en') return 'en';
      if (p.indexOf('/pl/') !== -1 || p === '/pl') return 'pl';
      return 'uk';  /* UA store default */
    }
    var SOC2_LANG = soc2DetectLang();

    function populatePopoverFromApi(panel) {
      if (!panel || panel.dataset.soc2ApiBreakdown !== '1') return;
      if (panel.__soc2ApiPopulated) return;

      var url = panel.dataset.soc2ApiUrl;
      var sym = panel.dataset.soc2CurrencySuffix || '₴';
      var rowsEl = panel.querySelector('[data-soc2-api-rows]');
      var sectionEl = panel.querySelector('[data-soc2-api-section]');
      var noteEl = panel.querySelector('[data-soc2-api-note]');

      fetchPricesOnce(url).then(function (data) {
        if (!data || !data.success || !data.prices) return;
        var prices = data.prices;
        var descs = data.description || {};

        /* Free quota config (e.g. "перший 1 безкоштовно" under «Аксесуар») */
        function resolveFreeKey(root, p) {
          if (!p || root == null) return null;
          return p.split('.').reduce(function (o, k) { return (o == null) ? null : o[k]; }, root);
        }
        var freeCfg = (function () {
          var configuredPath = panel.dataset.soc2FreePath || '';
          var template = panel.dataset.soc2FreeTmpl || 'перший [N] безкоштовно';
          /* Try configured path first, then common bundle/figurine keys */
          var keys = [configuredPath, 'freeAccessoriesBundle', 'freeAccessoriesPerFigure', 'freeAccessoriesMini', 'freeAccessories'];
          var n = null;
          for (var i = 0; i < keys.length && n == null; i++) {
            var v = resolveFreeKey(data, keys[i]);
            if (v == null) v = resolveFreeKey(prices, keys[i]);
            if (v != null) n = parseInt(v, 10);
          }
          return (n != null && !isNaN(n) && n > 0) ? { count: n, tmpl: template } : null;
        })();

        /* Render only paid figurine add-ons (price > 0). */
        var html = '';
        var rendered = 0;
        var labelDict = SOC2_ADDON_LABELS[SOC2_LANG] || SOC2_ADDON_LABELS.uk || {};
        FIG_ADDON_KEYS.forEach(function (k) {
          if (!prices.hasOwnProperty(k)) return;
          var price = prices[k];
          if (typeof price !== 'number' || price <= 0) return;
          /* Local-first label resolution — prefer our hand-tuned translation
             over the API description (which sometimes returns English text
             even for non-EN endpoints). */
          var label = labelDict[k] || descs[k] || k;
          /* Inject free-quota hint into the accessory row's label */
          var freeHint = '';
          if (k === 'accessory' && freeCfg) {
            freeHint = '<span class="soc2__pop-row-free-' + UID + '">'
                     + freeCfg.tmpl.replace('[N]', String(freeCfg.count)).replace('{N}', String(freeCfg.count))
                     + '</span>';
          }
          html += '<li class="soc2__pop-row-' + UID + '">'
                +   '<span class="soc2__pop-row-label-' + UID + '">' + label + freeHint + '</span>'
                +   '<span class="soc2__pop-row-price-' + UID + '">+' + price + '&nbsp;' + sym + '</span>'
                + '</li>';
          rendered++;
        });
        if (rowsEl) rowsEl.innerHTML = html;
        if (sectionEl) sectionEl.style.display = rendered > 0 ? '' : 'none';

        /* Discount note — uses bundleDiscount{N} where N = figure count. */
        if (noteEl) {
          var figCount = parseInt(panel.dataset.soc2FigureCount, 10);
          var discountKey = 'bundleDiscount' + figCount;
          var discount = prices[discountKey];
          if (typeof discount === 'number' && discount > 0) {
            var template = panel.dataset.soc2DiscountTmpl || 'Знижка -[p]% діє і на додаткові опції';
            noteEl.textContent = '💸 ' + template.replace('[p]', discount);
            noteEl.style.display = 'block';
          } else {
            noteEl.style.display = 'none';
          }
        }
        panel.__soc2ApiPopulated = true;
      });
    }

    function openPopover(idx) {
      var ov = document.querySelector('[data-soc2-pop-overlay="' + idx + '"]');
      var pn = document.querySelector('[data-soc2-pop-panel="' + idx + '"]');
      if (ov) ov.classList.add('is-active');
      if (pn) pn.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      /* Populate API-driven popover content lazily on first open */
      if (pn) populatePopoverFromApi(pn);
    }
    function closePopover(idx) {
      var selOv = idx ? '[data-soc2-pop-overlay="' + idx + '"]' : '[data-soc2-pop-overlay]';
      var selPn = idx ? '[data-soc2-pop-panel="' + idx + '"]'   : '[data-soc2-pop-panel]';
      document.querySelectorAll(selOv).forEach(function (n) { n.classList.remove('is-active'); });
      document.querySelectorAll(selPn).forEach(function (n) { n.classList.remove('is-active'); });
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-soc2-why]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopover(btn.getAttribute('data-soc2-why'));
      });
    });

    root.querySelectorAll('[data-soc2-trigger-global]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var overlays = document.querySelectorAll('[class*="ai-pop-overlay-"]');
        var panels = document.querySelectorAll('[class*="ai-pop-panel-"]');
        if (!overlays.length && !panels.length) return;

        document.querySelectorAll('[data-soc2-was-hidden]').forEach(function (n) {
          n.style.display = '';
          delete n.dataset.soc2WasHidden;
        });
        if (btn.getAttribute('data-soc2-hide-base') === '1') {
          panels.forEach(function (panel) {
            panel.querySelectorAll('[class*="ai-pop-highlight-"]').forEach(function (hl) {
              hl.dataset.soc2WasHidden = '1';
              hl.style.display = 'none';
            });
          });
        }
        overlays.forEach(function (n) { n.classList.add('is-active'); });
        panels.forEach(function (n) { n.classList.add('is-active'); });
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-soc2-pop-overlay]').forEach(function (ov) {
      ov.addEventListener('click', function () { closePopover(ov.getAttribute('data-soc2-pop-overlay')); });
    });
    document.querySelectorAll('[data-soc2-pop-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closePopover(btn.getAttribute('data-soc2-pop-close')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopover();
    });

    function parsePriceText(s) {
      if (!s) return NaN;
      var clean = s.replace(/[\s ]/g, '');
      var match = clean.match(/[\d.,]+/);
      if (!match) return NaN;
      var num = match[0];
      var hasDot = num.indexOf('.') !== -1;
      var hasComma = num.indexOf(',') !== -1;
      if (hasDot && hasComma) {
        var lastDot = num.lastIndexOf('.');
        var lastComma = num.lastIndexOf(',');
        var decSep = lastDot > lastComma ? '.' : ',';
        var thouSep = decSep === '.' ? ',' : '.';
        num = num.split(thouSep).join('');
        if (decSep === ',') num = num.replace(',', '.');
      } else if (hasComma) {
        var commaIdx = num.lastIndexOf(',');
        var afterComma = num.length - commaIdx - 1;
        if (afterComma === 3 && num.length > 4) num = num.replace(/,/g, '');
        else num = num.replace(',', '.');
      } else if (hasDot) {
        var dotIdx = num.lastIndexOf('.');
        var afterDot = num.length - dotIdx - 1;
        if (afterDot === 3 && num.length > 4) num = num.replace(/\./g, '');
      }
      return parseFloat(num);
    }
    function detectCurrency(s) {
      if (!s) return '';
      var stripped = s.replace(/[\d.,\s ]/g, '');
      return stripped.replace(/^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ]+/u, '');
    }
    function formatAmount(num) {
      var rounded = Math.round(num * 100) / 100;
      var str = (rounded % 1 === 0) ? rounded.toFixed(0) : rounded.toFixed(2);
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join('.');
    }
    root.querySelectorAll('[data-soc2-savings-auto]').forEach(function (el) {
      var oldP = parsePriceText(el.getAttribute('data-soc2-old'));
      var newP = parsePriceText(el.getAttribute('data-soc2-new'));
      if (isNaN(oldP) || isNaN(newP) || oldP <= newP) { el.style.display = 'none'; return; }
      var label = el.getAttribute('data-soc2-label') || '';
      var cur = detectCurrency(el.getAttribute('data-soc2-old')) || detectCurrency(el.getAttribute('data-soc2-new')) || '';
      el.textContent = (label ? label + ' ' : '') + formatAmount(oldP - newP) + cur;
    });
    root.querySelectorAll('[data-soc2-discount-auto]').forEach(function (el) {
      var oldP = parsePriceText(el.getAttribute('data-soc2-old'));
      var newP = parsePriceText(el.getAttribute('data-soc2-new'));
      if (isNaN(oldP) || isNaN(newP) || oldP <= newP) { el.style.display = 'none'; return; }
      el.textContent = '-' + Math.round((oldP - newP) / oldP * 100) + '%';
    });
    /* ══ designer path ════════════════════════════════════════════════════ */
    (function initDesigner() {
      var overlay = root.querySelector('[data-socd-overlay]');
      if (!overlay) return;
      var openBtn = root.querySelector('[data-socd-open]');          /* layout A */
      var ctaLink = root.querySelector('[data-soc2-cta]');           /* layout B */
      var LAYOUT  = CFG.layout;
      if (LAYOUT === 'two_buttons' && !openBtn) return;
      if (LAYOUT === 'choice_popup' && !ctaLink) return;

      function showStep(name) {
        var steps = overlay.querySelectorAll('[data-socd-step]');
        for (var i = 0; i < steps.length; i++) {
          steps[i].classList.toggle('is-active', steps[i].getAttribute('data-socd-step') === name);
        }
        var modal = overlay.querySelector('.socd__modal-' + UID + '');
        if (modal) modal.scrollTop = 0;
        overlay.scrollTop = 0;
      }

      var i18nEl = root.querySelector('[data-socd-i18n-' + UID + ']');
      var L = {};
      try { L = JSON.parse(i18nEl.textContent); } catch (e) { L = {}; }

      var dateInput = overlay.querySelector('[data-socd-date]');
      var wishesEl  = overlay.querySelector('[data-socd-wishes]');
      var submitBtn = overlay.querySelector('[data-socd-submit]');
      var errEl     = overlay.querySelector('[data-socd-err]');

      var picked = { qty: null, qtyTitle: '', variant: '', price: '', deadline: null, deadlineLabel: '', occasion: '', channel: '', figCount: 1, figures: null, size: null, sizeLabel: '' };

      /* ══ wizard state ═══════════════════════════════════════════════════
         `slots` is the composition the customer builds on step 1 — the same
         shape the constructor's own set-up screen produces. Everything else
         (totals, cart lines, the brief) is derived from it, so there is one
         source of truth for "who is in this set". */
      var slots = ['human'];
      var wiz = { fcolor: 'black', brick: 'white', bg: null, bgIdea: '', sign: '', occOther: '' };
      var MAX_BY_SIZE = { '13x18': 5, '18x13': 5, '18x18': 8, '25x25': 15, '21x30': 16, '30x21': 16 };
      var HARD_MAX = 16;
      var TYPE_EMOJI = { human: '🧍', animal: '🐾', baby: '👶' };

      /* ── frame brief: price = frame base (by size) + N × figureInFrame −
         tier discount on the figures part. Same maths and same prices API as
         the constructor (config/pricesConfig.ts + store/frame.ts), so the
         popup can never disagree with the builder about money. */
      var FRAME_MODE = submitBtn && submitBtn.getAttribute('data-socd-brief') === 'frame';

      /* «Оплата після макета»: логіка — assets/bt-design-request.js; тут лише
         міст REQX із замиканнями візарда. */
      var REQ_API = submitBtn ? (submitBtn.getAttribute('data-socd-request-api') || '') : '';
      var REQUEST_MODE = !!REQ_API;
      var REQX = null;
      if (REQUEST_MODE) {
        REQX = {
          overlay: overlay, submitBtn: submitBtn, errEl: errEl, L: L,
          api: REQ_API, frameMode: FRAME_MODE, contactEl: null, photos: [],
          state: function () { return { picked: picked, slots: slots, wiz: wiz, framePrices: framePrices }; },
          els: function () { return { dateInput: dateInput, wishesEl: wishesEl, signEl: signEl }; },
          h: { totals: totals, activeSize: activeSize, typePrice: typePrice, composeText: composeText,
               occText: occText, deadlineText: deadlineText, bgText: bgText, swLabel: swLabel,
               parsePriceText: parsePriceText, withRetry: withRetry, reportFailure: reportFailure,
               setBusy: setBusy, fail: fail, showStep: showStep, renderNav: renderNav, paneValid: paneValid }
        };
        (function reqBoot() {
          if (window.BTDesignRequest) { window.BTDesignRequest.init(REQX); }
          else { setTimeout(reqBoot, 120); }
        })();
      }
      var sizeTouched = false;

      /* Преселектимо НАЙМЕНШИЙ розмір, що вміщає композицію.
         ⚠⚠ Перелік розмірів — з каталогу конструктора (/admin/api/public/
         backgrounds, active=TRUE), НЕ з прайс-API: той тримає й вимкнені
         розміри (перша версія пропонувала неіснуючі 21×30/25×25). Фолбек
         без каталогу — консервативні 13×18 і 18×18. */
      var frameSizes = null; /* [{key, max}] у порядку каталогу */
      function fetchBgCatalog() {
        if (!FRAME_MODE || frameSizes) return Promise.resolve(frameSizes);
        var api = L.bgCatalogApi;
        if (!api) return Promise.resolve(null);
        return fetch(api).then(function (r) { return r.json(); }).then(function (list) {
          var out = [], seen = {};
          (Array.isArray(list) ? list : []).forEach(function (c) {
            var fs = String(c.frameSize || c.frame_size || '');
            if (!/^\d+x\d+$/.test(fs)) return;
            var key = fs;
            /* Горизонтальна орієнтація — та сама фізична рамка, повернута
               набік; показуємо її окремою карткою з перевернутим підписом,
               як робить пікер конструктора (13×18 vert + 18×13 horiz). */
            var parts = fs.split('x');
            if ((c.orientation === 'horizontal') && Number(parts[0]) < Number(parts[1])) key = parts[1] + 'x' + parts[0];
            if (seen[key]) return;
            seen[key] = true;
            var mf = Number(c.maxFigures || c.max_figures);
            out.push({ key: key, max: (isFinite(mf) && mf > 0) ? mf : (MAX_BY_SIZE[key] || 5) });
          });
          if (out.length) frameSizes = out;
          renderAll();
          return frameSizes;
        }).catch(function () { return null; });
      }
      function sizeEntries() {
        var src = frameSizes || [{ key: '13x18', max: MAX_BY_SIZE['13x18'] }, { key: '18x18', max: MAX_BY_SIZE['18x18'] }];
        /* Розмір продається, лише якщо на нього є ціна. */
        var out = [];
        for (var i = 0; i < src.length; i++) if (framePrices && apiNum(priceKeyOf(src[i].key))) out.push(src[i]);
        out.sort(function (a, b) { return a.max - b.max || (apiNum(priceKeyOf(a.key)) - apiNum(priceKeyOf(b.key))); });
        return out;
      }

      /* ── наявність рамки конкретного кольору: фід конструктора
         (/inventory/availability), SKU FRAME-{COLOR}-{W}-{H}; горизонтальна
         орієнтація ділить SKU з вертикальною. Фід null → все доступне:
         збій складу не зупиняє продаж, дизайнер переуточнить. */
      var INV = null, invLoaded = false;
      function fetchInventory() {
        if (!FRAME_MODE || invLoaded) return Promise.resolve(INV);
        var api = submitBtn.getAttribute('data-socd-prices-api');
        if (!api) return Promise.resolve(null);
        var host = api.split('/prices/')[0];
        return fetch(host + '/inventory/availability').then(function (r) { return r.json(); }).then(function (d) {
          var list = (d && d.products) || [];
          if (list.length) {
            INV = {};
            for (var i = 0; i < list.length; i++) INV[String(list[i].sku || '')] = list[i];
          }
          invLoaded = true;
          pickAvailableFrameColor();
          renderAll();
          return INV;
        }).catch(function () { invLoaded = true; return null; });
      }
      /* Дефолтний колір рамки може бути повністю розпроданий (на PL станом на
         15.08 чорних немає жодного розміру) — тоді перший же екран рамки
         відкривався заблокованим. Мовчки беремо колір, який Є, поки покупець
         не обрав колір сам. Дзеркало getFirstAvailableFrame у конструкторі:
         спершу тримаємось розміру, міняємо лише колір. */
      var fcolorTouched = false;
      function pickAvailableFrameColor() {
        if (!FRAME_MODE || fcolorTouched || !INV) return;
        var sz = activeSize();
        if (!sz || frameInStock(sz, wiz.fcolor)) return;
        var alts = ['black', 'white'], i;
        for (i = 0; i < alts.length; i++) {
          if (alts[i] !== wiz.fcolor && frameInStock(sz, alts[i])) {
            wiz.fcolor = alts[i];
            markSwatch('fcolor', wiz.fcolor);
            return;
          }
        }
      }
      function frameSkuOf(sizeKey, color) {
        var p = sizeKey.split('x');
        /* горизонтальний ключ → вертикальний SKU (та сама рамка боком) */
        if (Number(p[0]) > Number(p[1])) p = [p[1], p[0]];
        return 'FRAME-' + String(color || 'black').toUpperCase() + '-' + p[0] + '-' + p[1];
      }
      function frameInStock(sizeKey, color) {
        if (!INV) return true;
        var prod = INV[frameSkuOf(sizeKey, color)];
        if (!prod) return true; /* SKU не відстежується складом — не блокуємо */
        if (prod.available_to_order !== true) return false;
        if (typeof prod.free_to_order === 'number') return prod.free_to_order > 0;
        return Number(prod.available_for_order) > 0;
      }
      /* '18x13' — це повернута 13x18: ціна одна. */
      function priceKeyOf(key) {
        if (framePrices && Number(framePrices['frame' + key]) > 0) return 'frame' + key;
        var p = key.split('x');
        return 'frame' + p[1] + 'x' + p[0];
      }
      function sizeMax(key) {
        var list = sizeEntries();
        for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i].max;
        return MAX_BY_SIZE[key] || 5;
      }
      function recommendedSize() {
        var order = sizeEntries(), n = slots.length, i;
        /* Спершу — найменша рамка, яка і вміщує, і Є НА СКЛАДІ в обраному
           кольорі; якщо такої немає — найменша, яка просто вміщує. */
        for (i = 0; i < order.length; i++)
          if (order[i].max >= n && frameInStock(order[i].key, wiz.fcolor)) return order[i].key;
        for (i = 0; i < order.length; i++) if (order[i].max >= n) return order[i].key;
        return order.length ? order[order.length - 1].key : null;
      }
      function activeSize() { return picked.size || recommendedSize(); }

      var framePrices = null;
      /* Прайс потрібен обом режимам: рамці — щоб порахувати суму, фігуркам —
         щоб узяти БАЗОВУ ціну однієї фігурки. Він же приносить ПРАПОРЦІ
         НАЯВНОСТІ (bundleBabyEnabled / frameBabyEnabled) — тобто що саме
         показувати у виборі типів. Нічого з цього в темі не зашито. */
      function fetchFramePrices() {
        if (framePrices) return Promise.resolve(framePrices);
        var api = submitBtn.getAttribute('data-socd-prices-api');
        return fetch(api).then(function (r) { return r.json(); }).then(function (d) {
          framePrices = d && (d.prices || d);
          renderAll();
          return framePrices;
        }).catch(function () { return null; });
      }
      function apiNum(k) {
        var v = framePrices && Number(framePrices[k]);
        return (isFinite(v) && v > 0) ? v : null;
      }
      function baseFigurePrice() { return apiNum('figure'); }

      /* Ціна одного слота за типом. У рамці людина коштує figureInFrame, а не
         повну figure — саме так рахує конструктор рамки. */
      function typePrice(t) {
        if (t === 'human') return FRAME_MODE ? apiNum('figureInFrame') : apiNum('figure');
        if (t === 'animal') return apiNum('animal');
        if (t === 'baby') return apiNum('baby');
        return null;
      }
      /* Наявність типу = є ціна в API (+ окремий тумблер для малюка). */
      function typeAvailable(t) {
        if (!framePrices) return t === 'human';
        if (t === 'baby') {
          var flag = Number(framePrices[FRAME_MODE ? 'frameBabyEnabled' : 'bundleBabyEnabled']);
          if (flag !== 1) return false;
        }
        return typePrice(t) != null;
      }
      function availableTypes() {
        var all = ['human', 'animal', 'baby'], out = [];
        for (var i = 0; i < all.length; i++) if (typeAvailable(all[i])) out.push(all[i]);
        return out.length ? out : ['human'];
      }

      /* ── знижки ────────────────────────────────────────────────────────────
         Набір: модель автоматичних знижок Shopify (та сама, що в конструкторі,
         config/pricesConfig.ts) — блоки повторюються, неповний блок не рахується,
         діє ОДНЕ найвигідніше правило, і лягає воно на НАЙДЕШЕВШІ позиції.
         Рамка: тірний % від суми фігурок. Обидва набори відсотків — з API. */
      function bundleRules() {
        var r = [];
        var d2 = Number(framePrices && framePrices.bundleDiscount2) || 0;
        var d3 = Number(framePrices && framePrices.bundleDiscount3) || 0;
        var d5 = Number(framePrices && framePrices.bundleDiscount5) || 0;
        if (d2 > 0) r.push({ block: 2, get: 1, pct: d2 });
        if (d3 > 0) { r.push({ block: 3, get: 2, pct: d3 }); r.push({ block: 4, get: 3, pct: d3 }); }
        if (d5 > 0) { r.push({ block: 5, get: 4, pct: d5 }); r.push({ block: 6, get: 5, pct: d5 }); }
        return r;
      }
      function bundleDiscount(prices) {
        var n = prices.length, empty = { total: 0, pct: 0 };
        if (n < 2) return empty;
        var order = [], i;
        for (i = 0; i < n; i++) order.push(i);
        order.sort(function (a, b) { return (prices[a] - prices[b]) || (b - a); });
        var rules = bundleRules(), best = empty;
        for (i = 0; i < rules.length; i++) {
          var m = Math.floor(n / rules[i].block) * rules[i].get;
          if (m <= 0) continue;
          var total = 0;
          for (var k = 0; k < m; k++) total += Math.round(prices[order[k]] * rules[i].pct) / 100;
          if (total > best.total) best = { total: total, pct: rules[i].pct };
        }
        return best;
      }
      function frameDiscountPct(n) {
        var tiers = [[15, 'frameDiscount15'], [10, 'frameDiscount10'], [6, 'frameDiscount6'], [4, 'frameDiscount4'], [2, 'frameDiscount2']];
        for (var i = 0; i < tiers.length; i++) {
          if (n >= tiers[i][0]) {
            var p = Number(framePrices && framePrices[tiers[i][1]]) || 0;
            if (p > 0) return p;
          }
        }
        return 0;
      }
      /* Маржинальний % для бейджа на позиції — як getBundleDiscountPercentForPosition. */
      function bundlePctForPosition(pos) {
        var base = typePrice('human');
        if (!base) return 0;
        var before = [], i;
        for (i = 0; i < pos - 1; i++) before.push(base);
        var after = before.slice(); after.push(base);
        var res = bundleDiscount(after);
        var delta = res.total - bundleDiscount(before).total;
        if (delta <= 0) return 0;
        return Math.min(res.pct, Math.round(delta / base * 100));
      }
      function slotDiscountPct(pos) {
        return FRAME_MODE ? frameDiscountPct(slots.length) : bundlePctForPosition(pos);
      }

      function slotPrices() {
        var out = [];
        for (var i = 0; i < slots.length; i++) out.push(typePrice(slots[i]) || 0);
        return out;
      }
      /* Підсумок. Рамка: рамка + фігурки − тірна знижка. Набір: сума фігурок
         − драбина Shopify (кошик порахує так само, бо модель одна). */
      function totals() {
        var p = slotPrices(), i, figSub = 0;
        for (i = 0; i < p.length; i++) figSub += p[i];
        if (FRAME_MODE) {
          var sz = activeSize();
          var frame = sz ? (apiNum(priceKeyOf(sz)) || 0) : 0;
          var save = Math.round(figSub * frameDiscountPct(slots.length) / 100);
          return { full: frame + figSub, save: save, total: frame + figSub - save, frame: frame };
        }
        var d = Math.round(bundleDiscount(p).total);
        return { full: figSub, save: d, total: figSub - d, frame: 0 };
      }

      /* ── строки виготовлення ───────────────────────────────────────────────
         Живий графік складу: `schedule.days` каже, які дні реально робочі
         (вихідні, свята, зміни). Без нього — фолбек на будні. */
      var DS = null, DSDAY = {};
      function isoOf(d) {
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      }
      function fetchDelivery() {
        var api = L.deliveryApi;
        if (!api) return Promise.resolve(null);
        return fetch(api).then(function (r) { return r.json(); }).then(function (d) {
          DS = (d && d.settings) ? d.settings : d;
          var days = DS && DS.schedule && DS.schedule.days;
          if (days && days.length) for (var i = 0; i < days.length; i++) DSDAY[days[i].date] = !!days[i].is_working;
          renderAll();
          return DS;
        }).catch(function () { return null; });
      }
      function isWorkDay(d) {
        var iso = isoOf(d);
        if (DSDAY.hasOwnProperty(iso)) return DSDAY[iso];
        if (DS && DS.works_on_weekends) return true;
        var w = d.getDay();
        return w !== 0 && w !== 6;
      }
      function addWorkDays(from, n) {
        var d = new Date(from.getTime()), guard = 0;
        while (n > 0 && guard++ < 400) { d.setDate(d.getDate() + 1); if (isWorkDay(d)) n--; }
        return d;
      }
      function num(v, dflt) { var x = Number(v); return isFinite(x) ? x : dflt; }
      function computeDates() {
        var now = new Date(), rush;
        var cutoff = num(DS && DS.same_day_cutoff_hour, 12);
        if (DS && DS.same_day_enabled && isWorkDay(now) && now.getHours() < cutoff) rush = new Date(now.getTime());
        else rush = addWorkDays(now, 1);
        var minD = num(DS && DS.standard_delivery_min_days, 2);
        var maxD = num(DS && DS.standard_delivery_max_days, 4);
        return {
          rush: rush,
          stdFrom: addWorkDays(now, minD),
          stdTo: addWorkDays(now, maxD),
          relaxMax: addWorkDays(now, maxD + 3)
        };
      }
      function fmtD(d) {
        return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
      }
      function stdRange() { var c = computeDates(); return fmtD(c.stdFrom) + '–' + fmtD(c.stdTo); }

      /* ⚠ Терміновість — це ОКРЕМИЙ товар «Швидка відправка», який покупець
         додає вже в КОШИКУ (FastDeliverySystem у blocks/_cart-summary.liquid),
         а не доплата всередині цієї лінії. Тут рахуємо лише орієнтовну суму —
         тією самою формулою і тією самою тарифною сіткою, щоб людина побачила
         в кошику рівно те число, яке ми назвали. */
      var EXPRESS_TIERS = String(L.expressTiers || '').split(',').map(Number).filter(function (n) { return n > 0; });
      if (!EXPRESS_TIERS.length) EXPRESS_TIERS = [75, 99, 124, 149, 174, 199, 224, 249, 274, 299, 324, 349, 374, 399, 424, 449];
      function expressFee(cartTotal) {
        var raw, i;
        if (DS && DS.express_paid === true && typeof DS.express_price_value === 'number') {
          if ((DS.express_price_type || 'percent') === 'fixed') raw = Math.max(1, Math.round(DS.express_price_value));
          else {
            raw = Math.floor(cartTotal * DS.express_price_value / 100);
            if (DS.express_price_type === 'percent_capped' && Number(DS.express_price_max) > 0) raw = Math.min(raw, Math.round(DS.express_price_max));
            raw = Math.max(1, raw);
          }
        } else {
          var lo = EXPRESS_TIERS[0], hi = EXPRESS_TIERS[EXPRESS_TIERS.length - 1];
          raw = Math.min(hi, Math.max(lo, Math.floor(cartTotal * 0.15)));
        }
        /* PL бере НАЙБЛИЖЧИЙ щабель у будь-який бік, UA — найближчий ВГОРУ. */
        if (L.expressPick === 'near') {
          var best = EXPRESS_TIERS[0];
          for (i = 0; i < EXPRESS_TIERS.length; i++) {
            if (Math.abs(EXPRESS_TIERS[i] - raw) < Math.abs(best - raw)) best = EXPRESS_TIERS[i];
          }
          return best;
        }
        for (i = 0; i < EXPRESS_TIERS.length; i++) if (raw <= EXPRESS_TIERS[i]) return EXPRESS_TIERS[i];
        return EXPRESS_TIERS[EXPRESS_TIERS.length - 1];
      }
      function cur() { return submitBtn.getAttribute('data-socd-cur') || ''; }
      function money(v) { return formatAmount(v) + ' ' + cur(); }
      function tpl(s, map) {
        s = String(s || '');
        for (var k in map) if (map.hasOwnProperty(k)) s = s.split('[' + k + ']').join(map[k]);
        return s;
      }
      /* Раніше в кошик летів варіант за ціною КАРТКИ (2100 за дві) одним рядком:
         Shopify бачив один товар, автознижка за кількість не вмикалась, а сума
         була зашита в назву варіанта. Тепер кладемо N базових фігурок і знижку
         рахує кошик — так само, як для збірок із конструктора. Тому й показуємо
         суму ДО знижки з поясненням, а не готовий підсумок. */
      /* ── рендер ────────────────────────────────────────────────────────── */
      var elSlots   = overlay.querySelector('[data-socd-slots]');
      var elAddSlot = overlay.querySelector('[data-socd-addslot]');
      var elLadder  = overlay.querySelector('[data-socd-ladder]');
      var elSizes   = overlay.querySelector('[data-socd-sizes]');
      var elSizeWarn= overlay.querySelector('[data-socd-sizewarn]');
      var elDl      = overlay.querySelector('[data-socd-dl]');
      var elDlNote  = overlay.querySelector('[data-socd-dlnote]');
      var elSummary = overlay.querySelector('[data-socd-summary]');
      var elProg    = overlay.querySelector('[data-socd-prog]');
      var elStepNo  = overlay.querySelector('[data-socd-stepno]');
      var elStepNm  = overlay.querySelector('[data-socd-stepname]');
      var elCrumbs  = overlay.querySelector('[data-socd-crumbs]');
      var nextBtn   = overlay.querySelector('[data-socd-next]');
      var prevBtn   = overlay.querySelector('[data-socd-prev]');
      var skipBtn   = overlay.querySelector('[data-socd-skip]');
      var bgIdeaEl  = overlay.querySelector('[data-socd-bgidea]');
      var occOtherEl= overlay.querySelector('[data-socd-occ-other]');
      var signEl    = overlay.querySelector('[data-socd-sign]');

      var PANES = [];
      (function () {
        var list = overlay.querySelectorAll('[data-socd-w]');
        for (var i = 0; i < list.length; i++) PANES.push(list[i].getAttribute('data-socd-w'));
      })();
      var PANE_NAME = {
        compose: FRAME_MODE ? (L.stCompose || '') : (L.stCompose || ''),
        format: L.stFormat || '', frame: L.stFrame || '', bg: L.stBg || '',
        deadline: L.stDeadline || '', occasion: L.stOccasion || '', contact: L.stContact || ''
      };
      var cur_ = 0;
      /* offer_mode (є слот [data-po-price-slot] блока bt-photo-offer): кроки показуються групами —
         «хто / формат / рамка й фон» · «коли / привід» · «контакт і фото» — 3 екрани замість 5–6.
         cur_ і далі — індекс панелі; екран = група, в якій вона лежить. */
      var GROUPS = null;
      if (document.querySelector('[data-po-price-slot]')) {
        var gA = [], gB = [], gC = [];
        for (var gi = 0; gi < PANES.length; gi++) {
          var gp = PANES[gi];
          if (gp === 'deadline' || gp === 'occasion') gB.push(gi);
          else if (gp === 'contact') gC.push(gi);
          else gA.push(gi);
        }
        GROUPS = [gA, gB, gC].filter(function (g) { return g.length; });
        overlay.classList.add('po-offer');
      }
      function scrIdx(i) { if (!GROUPS) return i; for (var g = 0; g < GROUPS.length; g++) if (GROUPS[g].indexOf(i) >= 0) return g; return 0; }
      function scr(i) { return GROUPS ? GROUPS[scrIdx(i)] : [i]; }
      function pane() { return PANES[cur_]; }
      function isLast() { return GROUPS ? scrIdx(cur_) === GROUPS.length - 1 : cur_ === PANES.length - 1; }
      function stepTo(dir) { if (!GROUPS) return cur_ + dir; var g = GROUPS[scrIdx(cur_) + dir]; return g ? g[0] : cur_; }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
        });
      }
      function typeLabel(t) { return t === 'human' ? (L.tHuman || 'Human') : t === 'animal' ? (L.tAnimal || 'Pet') : (L.tBaby || 'Baby'); }
      function typeImg(t) { return (L.typeImages && L.typeImages[t]) || ''; }

      /* img з падінням в емодзі: асет можуть не залити (нова тема, PL-копія) —
         битих іконок покупець бачити не повинен. */
      function typeImgHtml(t, px) {
        var img = typeImg(t);
        var emoji = '<span style="font-size:' + Math.round(px * 0.75) + 'px;line-height:' + px + 'px' + (img ? ';display:none' : '') + '">' + TYPE_EMOJI[t] + '</span>';
        if (!img) return emoji;
        return '<img src="' + esc(img) + '" alt="" style="width:' + px + 'px;height:' + px + 'px;object-fit:contain" ' +
               'onerror="this.style.display=\'none\';if(this.nextElementSibling)this.nextElementSibling.style.display=\'\'">' + emoji;
      }

      function renderSlots() {
        if (!elSlots) return;
        var types = availableTypes(), html = '', i;
        for (i = 0; i < slots.length; i++) {
          var fixed = i === 0;
          var pct = slotDiscountPct(i + 1);
          if (fixed) {
            /* Слот 0 без вибору — тонкий рядок замість картки на пів екрана. */
            html += '<div class="socd__slotfixed-' + UID + '">' + typeImgHtml('human', 30) +
                    '<span class="nm">' + esc(L.slotN || 'Figure') + ' 1 · ' + esc(typeLabel('human')) + '</span>' +
                    '<span class="in">' + esc(FRAME_MODE ? (L.slotIncl || '') : (L.slotMain || '')) + '</span></div>';
            continue;
          }
          html += '<div class="socd__slot-' + UID + '"><div class="socd__slothead-' + UID + '">';
          html += '<div class="socd__slotn-' + UID + '">' + esc(L.slotN || 'Figure') + ' ' + (i + 1) + '</div>';
          html += '<div class="socd__slotright-' + UID + '">';
          if (pct > 0) html += '<span class="socd__slotdisc-' + UID + '">−' + pct + '%</span>';
          html += '<button type="button" class="socd__slotrm-' + UID + '" data-socd-slotrm="' + i + '">✕</button>';
          html += '</div></div>';
          html += '<div class="socd__types-' + UID + '" style="grid-template-columns:repeat(' + types.length + ',minmax(0,1fr))">';
          for (var j = 0; j < types.length; j++) {
            var t = types[j], full = typePrice(t), save = full ? Math.round(full * pct / 100) : 0, fin = full ? full - save : null;
            html += '<button type="button" class="socd__type-' + UID + '' + (slots[i] === t ? ' is-on' : '') + '"' +
                    ' data-socd-slotset="' + i + '|' + t + '">';
            html += typeImgHtml(t, 34);
            html += '<span class="socd__typenm-' + UID + '">' + esc(typeLabel(t)) + '</span>';
            if (full == null) html += '<span class="socd__typepr-' + UID + '">—</span>';
            else if (pct > 0) html += '<span class="socd__typepr-' + UID + '"><b>' + money(fin) + '</b><s>' + money(full) + '</s></span>';
            else html += '<span class="socd__typepr-' + UID + '">' + (FRAME_MODE ? '' : esc(L.fromWord || '') + ' ') + money(full) + '</span>';
            html += '</button>';
          }
          html += '</div></div>';
        }
        elSlots.innerHTML = html;

        var q = overlay.querySelector('[data-socd-compose-q]');
        if (q) q.innerHTML = esc(FRAME_MODE ? (L.qComposeF || '') : (L.qCompose || '')) +
          ' <span>' + esc(L.composeHint || '') + '</span>';
        if (elAddSlot) {
          elAddSlot.textContent = L.addFigure || '+';
          /* Рамка: стеля = найбільша рамка, яка ЗАРАЗ продається (з каталогу),
             а не теоретичний максимум — інакше пропонуємо додати 9-ту фігурку,
             коли найбільша доступна рамка вміщує 8. */
          var lim = 12;
          if (FRAME_MODE) {
            var es = sizeEntries(), m = 0;
            for (var q2 = 0; q2 < es.length; q2++) if (es[q2].max > m) m = es[q2].max;
            lim = m || HARD_MAX;
          }
          if (slots.length >= lim) elAddSlot.setAttribute('disabled', 'disabled');
          else elAddSlot.removeAttribute('disabled');
        }
        if (elLadder) {
          var t2 = totals(), parts = [];
          if (t2.save > 0) parts.push(esc(L.ladderHave || '') + ' <b>−' + money(t2.save) + '</b>.');
          if (!FRAME_MODE) {
            var nx = bundlePctForPosition(slots.length + 1);
            if (nx > 0) parts.push(esc(L.ladderNext || '') + ' <b>−' + nx + '%</b>.');
          } else {
            var rec = recommendedSize();
            if (rec) parts.push(esc(tpl(L.sizeAuto || '', { N: slots.length })));
          }
          elLadder.innerHTML = parts.join(' ');
          elLadder.style.display = parts.length ? '' : 'none';
        }
      }

      function renderSizes() {
        if (!elSizes || !FRAME_MODE) return;
        var order = sizeEntries(), act = activeSize(), rec = recommendedSize(), n = slots.length;
        var base = order.length ? apiNum(priceKeyOf(order[0].key)) : null;
        var html = '';
        for (var i = 0; i < order.length; i++) {
          var s = order[i].key, price = apiNum(priceKeyOf(s)) || 0, up = base ? price - base : 0;
          var vertical = Number(s.split('x')[0]) < Number(s.split('x')[1]);
          var square = Number(s.split('x')[0]) === Number(s.split('x')[1]);
          var w = square ? 56 : (vertical ? 44 : 62), h = square ? 56 : (vertical ? 62 : 44);
          var img = L.frameImages && L.frameImages[s];
          var oos = !frameInStock(s, wiz.fcolor);
          html += '<button type="button" class="socd__size-' + UID + '' + (act === s ? ' is-on' : '') +
                  ((order[i].max < n || oos) ? ' is-tight' : '') + '" data-socd-size="' + s + '">';
          if (s === rec && !oos) html += '<span class="socd__sizerec-' + UID + '">' + esc(L.rec || '') + '</span>';
          /* Реальний рендер рамки з assets; якщо асета немає — CSS-прямокутник
             правильної пропорції, як у пікері конструктора. */
          html += '<div class="socd__sizeph-' + UID + '">' +
                  (img ? '<img src="' + esc(img) + '" alt="" onerror="this.outerHTML=\'<span style=&quot;display:block;width:' + w + 'px;height:' + h + 'px;border:3px solid #2b2b2b;border-radius:3px;background:#f4f4f6&quot;></span>\'">'
                       : '<span style="display:block;width:' + w + 'px;height:' + h + 'px;border:3px solid #2b2b2b;border-radius:3px;background:#f4f4f6"></span>') +
                  '</div>';
          html += '<div class="socd__sizenm-' + UID + '">' + esc(s.replace('x', '×')) + ' ' + esc('см') + '</div>';
          html += '<div class="socd__sizemx-' + UID + '">' + esc(tpl(L.sizeMax || '', { N: order[i].max })) + '</div>';
          if (oos) html += '<div class="socd__sizeup-' + UID + '" style="color:#b45309">' + esc(L.oos || '') + '</div>';
          else html += '<div class="socd__sizeup-' + UID + '"' + (up > 0 ? '' : ' style="color:#b6b6c2"') + '>' +
                  (up > 0 ? '+' + money(up) : esc(L.sizeBase || '')) + '</div>';
          html += '</button>';
        }
        elSizes.innerHTML = html;

        var szMax = sizeMax(act);
        if (elSizeWarn) {
          if (act && szMax < n) {
            elSizeWarn.innerHTML = tpl(L.sizeWarn || '', { M: szMax, N: n });
            elSizeWarn.style.display = '';
          } else if (act && !frameInStock(act, wiz.fcolor)) {
            elSizeWarn.innerHTML = tpl(L.oosWarn || '', { S: act.replace('x', '×') });
            elSizeWarn.style.display = '';
          } else elSizeWarn.style.display = 'none';
        }
        var hint = overlay.querySelector('[data-socd-size-hint]');
        if (hint) hint.textContent = sizeTouched
          ? tpl(L.sizeManual || '', { N: n, S: (rec || '').replace('x', '×') })
          : tpl(L.sizeAuto || '', { N: n });
      }

      /* Значення дедлайну лишаються тими самими (rush/free/date/relax) — їх
         whitelist-ять обидва парсери брифу (склад TS + kickflip Python). */
      function renderDeadline() {
        if (!elDl) return;
        var c = computeDates(), now = new Date();
        var tom = new Date(now.getTime()); tom.setDate(tom.getDate() + 1);
        var rushTxt = fmtD(c.rush) === fmtD(now) ? (L.today || '')
                    : fmtD(c.rush) === fmtD(tom) ? (L.tomorrow || '') + ', ' + fmtD(c.rush)
                    : fmtD(c.rush);
        var fee = expressFee(totals().total);
        var rows = [
          { v: 'rush',  nm: L.dlRush || '',  sub: L.dlRushS || '',  date: rushTxt, tag: (L.tagPay || '') + money(fee), tagCls: 'is-pay' },
          { v: 'free',  nm: L.dlStd || '',   sub: L.dlStdS || '',   date: stdRange(), tag: L.tagFree || '', tagCls: 'is-free' },
          { v: 'date',  nm: L.dlDate || '',  sub: L.dlDateS || '',  date: L.dlDatePick || '', tag: '', tagCls: '' },
          { v: 'relax', nm: L.dlRelax || '', sub: L.dlRelaxS || '', date: (L.until || '') + ' ' + fmtD(c.relaxMax), tag: L.tagGift || '', tagCls: 'is-gift' }
        ];
        var html = '';
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          html += '<button type="button" class="socd__opt-' + UID + '' + (picked.deadline === r.v ? ' is-on' : '') +
                  '" data-socd-dlval="' + r.v + '"><div class="socd__optrow-' + UID + '">' +
                  '<span class="socd__optnm-' + UID + '">' + esc(r.nm) + '</span>' +
                  (r.tag ? '<span class="socd__tag-' + UID + ' ' + r.tagCls + '">' + esc(r.tag) + '</span>' : '') +
                  '<span class="socd__optdate-' + UID + '">' + esc(r.date) + '</span></div>' +
                  '<div class="socd__optsub-' + UID + '">' + esc(r.sub) + '</div></button>';
        }
        elDl.innerHTML = html;
        renderDlNote();
      }
      function dateIsRush() {
        if (!dateInput || !dateInput.value) return false;
        var c = computeDates();
        return new Date(dateInput.value) < new Date(c.stdFrom.toDateString());
      }
      function renderDlNote() {
        if (!elDlNote) return;
        var c = computeDates(), fee = money(expressFee(totals().total)), html = '', cls = '';
        if (picked.deadline === 'rush') { html = tpl(L.noteRush || '', { F: fee }); cls = 'is-rush'; }
        else if (picked.deadline === 'free') { html = tpl(L.noteStd || '', { D: stdRange() }); cls = 'is-std'; }
        else if (picked.deadline === 'relax') { html = tpl(L.noteRelax || '', { D: fmtD(c.relaxMax) }); cls = 'is-relax'; }
        else if (picked.deadline === 'date' && dateInput && dateInput.value) {
          if (dateIsRush()) { html = tpl(L.noteDateRush || '', { F: fee, D: stdRange() }); cls = 'is-rush'; }
          else { html = tpl(L.noteDateOk || '', { D: fmtD(new Date(dateInput.value)) }); cls = 'is-std'; }
        }
        elDlNote.className = 'socd__dnote-' + UID + ' ' + cls;
        elDlNote.innerHTML = html;
        elDlNote.style.display = html ? '' : 'none';
      }

      function composeText() {
        var c = {}, out = [], i;
        for (i = 0; i < slots.length; i++) c[slots[i]] = (c[slots[i]] || 0) + 1;
        for (var k in c) if (c.hasOwnProperty(k)) out.push(c[k] + ' × ' + typeLabel(k));
        return out.join(', ');
      }
      function occText() {
        if (picked.occasion === '__other') return (wiz.occOther || '').trim();
        return picked.occasion || '';
      }
      function swLabel(group, val) {
        var b = overlay.querySelector('[data-socd-group2="' + group + '"] [data-socd-val="' + val + '"]');
        return b ? (b.getAttribute('data-socd-label') || val) : val;
      }
      function bgText() {
        if (!wiz.bg) return '';
        var lbl = swLabel('bg', wiz.bg);
        if (wiz.bg === 'idea' && (wiz.bgIdea || '').trim()) return lbl + ': ' + wiz.bgIdea.trim();
        return lbl;
      }

      function renderSummary() {
        if (!elSummary) return;
        var t = totals(), rows = [];
        rows.push([L.sumCompose || '', composeText()]);
        if (FRAME_MODE) {
          var sz = activeSize();
          rows.push([L.sumFrame || '', (sz ? sz.replace('x', '×') + ' см, ' : '') + swLabel('fcolor', wiz.fcolor)]);
          if (bgText()) rows.push([L.sumBg || '', bgText()]);
          rows.push([L.sumBrick || '', swLabel('brick', wiz.brick)]);
        } else if (picked.keychainLabel) {
          rows.push([L.keychain || '', picked.keychainLabel]);
        }
        rows.push([L.deadline || '', deadlineText()]);
        if (occText()) rows.push([L.occasion || '', occText()]);
        if (signEl && signEl.value.trim()) rows.push([L.propSign || '', signEl.value.trim()]);
        if (wishesEl && wishesEl.value.trim()) rows.push([L.wishes || '', wishesEl.value.trim().slice(0, 60)]);
        if (picked.channel) rows.push([L.channel || '', picked.channel]);
        if (t.save > 0) rows.push([L.sumDisc || '', '−' + money(t.save)]);
        var html = '';
        for (var i = 0; i < rows.length; i++) {
          html += '<div class="socd__sumline-' + UID + '"><span class="socd__sumk-' + UID + '">' + esc(rows[i][0]) +
                  '</span><span class="socd__sumv-' + UID + '">' + esc(rows[i][1]) + '</span></div>';
        }
        elSummary.innerHTML = html;
      }

      /* Людський текст дедлайну — він же їде у properties, тому містить дати. */
      function deadlineText() {
        var c = computeDates();
        if (picked.deadline === 'rush') return (L.dlRush || '') + ' — ' + (fmtD(c.rush) === fmtD(new Date()) ? (L.today || '') : fmtD(c.rush));
        if (picked.deadline === 'free') return (L.dlStd || '') + ' — ' + stdRange();
        if (picked.deadline === 'date') return (L.dlDate || '') + ': ' + ((dateInput && dateInput.value) || '');
        if (picked.deadline === 'relax') return (L.dlRelax || '') + ' (' + (L.until || '') + ' ' + fmtD(c.relaxMax) + ')';
        return '';
      }

      function renderTotal() {
        var el = overlay.querySelector('[data-socd-total]');
        var old = overlay.querySelector('[data-socd-total-old]');
        var sub = overlay.querySelector('[data-socd-total-sub]');
        var note = overlay.querySelector('[data-socd-qty-note]');
        if (!el) return;
        var t = totals();
        if (!framePrices) { el.textContent = picked.price || '…'; return; }
        el.textContent = money(t.total);
        if (old) old.textContent = t.save > 0 ? money(t.full) : '';
        var isRush = picked.deadline === 'rush' || (picked.deadline === 'date' && dateIsRush());
        if (sub) sub.textContent = isRush ? tpl(L.expressNote || '', { F: money(expressFee(t.total)) }) : '';
        if (note) note.style.display = 'none';
        renderBreakdown();
      }

      /* «Склад ціни» під ⓘ — ті самі числа, що в totals(), розписані по
         рядках: рамка за розміром, кожен тип × кількість, знижка, разом. */
      function renderBreakdown() {
        var box = overlay.querySelector('[data-socd-brk]');
        if (!box || !framePrices) return;
        var t = totals(), rows = [], i;
        if (FRAME_MODE && activeSize()) {
          rows.push([(L.sumFrame || 'Frame') + ' ' + activeSize().replace('x', '×'), money(t.frame)]);
        }
        var counts = {}, order = [];
        for (i = 0; i < slots.length; i++) {
          if (!counts[slots[i]]) { counts[slots[i]] = 0; order.push(slots[i]); }
          counts[slots[i]]++;
        }
        for (i = 0; i < order.length; i++) {
          var tp = order[i], p = typePrice(tp) || 0;
          rows.push([counts[tp] + ' × ' + typeLabel(tp), money(p * counts[tp])]);
        }
        var html = '<div class="socd__brkt-' + UID + '">' + esc(L.brkTitle || '') + '</div>';
        for (i = 0; i < rows.length; i++) {
          html += '<div class="socd__brkr-' + UID + '"><span>' + esc(rows[i][0]) + '</span><b>' + rows[i][1] + '</b></div>';
        }
        if (t.save > 0) {
          html += '<div class="socd__brkr-' + UID + ' is-disc"><span>' + esc(L.sumDisc || '') + '</span><b>−' + money(t.save) + '</b></div>';
        }
        html += '<div class="socd__brkr-' + UID + ' is-total"><span>' + esc(L.brkTotal || '') + '</span><b>' + money(t.total) + '</b></div>';
        box.innerHTML = html;
      }

      function renderNav() {
        if (elProg) {
          var h = '';
          var nTot = GROUPS ? GROUPS.length : PANES.length, nCur = scrIdx(cur_);
          for (var i = 0; i < nTot; i++) h += '<i class="' + (i <= nCur ? 'is-done' : '') + '"></i>';
          elProg.innerHTML = h;
        }
        if (elStepNo) elStepNo.innerHTML = esc(L.stepWord || '') + ' <b>' + (scrIdx(cur_) + 1) + '</b> ' + esc(L.stepOf || '') + ' <b>' + (GROUPS ? GROUPS.length : PANES.length) + '</b>';
        if (elStepNm) elStepNm.textContent = PANE_NAME[pane()] || '';
        if (prevBtn) prevBtn.style.visibility = cur_ > 0 ? 'visible' : 'hidden';
        if (nextBtn) {
          nextBtn.textContent = isLast() ? (L.submit || '') : (L.next || '');
          /* offer_mode: кнопка не «мертва» — сіра, але клікабельна: по кліку показуємо, чого бракує. */
          if (GROUPS) { nextBtn.removeAttribute('disabled'); nextBtn.classList.toggle('is-off', !paneValid()); }
          else if (paneValid()) nextBtn.removeAttribute('disabled');
          else nextBtn.setAttribute('disabled', 'disabled');
        }
        if (skipBtn) skipBtn.style.display = (pane() === 'occasion') ? '' : 'none';
        /* Гарантія — на дедлайні (де вона знімає страх «а якщо не встигнуть»)
           і на фіналі (де людина тисне «Додати в кошик»). На решті кроків вона
           лише розтягувала скрол. */
        var guar = overlay.querySelector('[data-socd-guar]');
        if (guar) guar.style.display = (pane() === 'deadline' || isLast()) ? '' : 'none';
        /* Приписка про оплату/чергу — так само лише там, де вона доречна. */
        var fine = overlay.querySelector('[data-socd-fine]');
        if (fine) fine.style.display = (pane() === 'deadline' || isLast()) ? '' : 'none';
        if (elCrumbs) {
          var html = '';
          for (var j = 0; j < scr(cur_)[0]; j++) {
            var txt = crumbText(PANES[j]);
            if (!txt) continue;
            html += '<button type="button" class="socd__crumb-' + UID + '" data-socd-goto="' + j + '">' + esc(txt) + ' <span>✎</span></button>';
          }
          elCrumbs.innerHTML = html;
        }
      }
      function crumbText(p) {
        if (p === 'compose') {
          var c = {}, out = [], i;
          for (i = 0; i < slots.length; i++) c[slots[i]] = (c[slots[i]] || 0) + 1;
          for (var k in c) if (c.hasOwnProperty(k)) out.push(TYPE_EMOJI[k] + ' ' + c[k]);
          return out.join(' + ');
        }
        if (p === 'format') return picked.keychainLabel || '';
        if (p === 'frame') { var s = activeSize(); return '🖼️ ' + (s ? s.replace('x', '×') : '') + ' · ' + swLabel('fcolor', wiz.fcolor); }
        if (p === 'bg') return bgText() ? '🎨 ' + bgText().slice(0, 26) : '';
        if (p === 'deadline') return deadlineText().slice(0, 34);
        if (p === 'occasion') return occText();
        return '';
      }
      function paneValid(pp) {
        if (GROUPS && !pp) {
          var sc = scr(cur_);
          for (var si = 0; si < sc.length; si++) if (!paneValid(PANES[sc[si]])) return false;
          return true;
        }
        var p = pp || pane();
        if (p === 'compose') return slots.length > 0;
        if (p === 'format') return !!picked.keychain;
        if (p === 'frame') {
          var s = activeSize();
          return !!s && sizeMax(s) >= slots.length && frameInStock(s, wiz.fcolor);
        }
        if (p === 'bg') return !!wiz.bg;
        if (p === 'deadline') return !!picked.deadline && (picked.deadline !== 'date' || !!(dateInput && dateInput.value));
        if (p === 'occasion') return true;
        if (p === 'contact') {
          /* У заявці контакт обовʼязковий — саме туди полетить макет. */
          if (REQUEST_MODE) return !!picked.channel && !!(REQX && REQX.validContact && REQX.validContact());
          return !!picked.channel;
        }
        return true;
      }
      function showPane() {
        var list = overlay.querySelectorAll('[data-socd-w]');
        var sc = scr(cur_);
        for (var i = 0; i < list.length; i++) list[i].classList.toggle('is-active', sc.indexOf(i) >= 0);
        var modal = overlay.querySelector('.socd__modal-' + UID + '');
        if (modal) modal.scrollTop = 0;
        /* на мобільному скролер — сам оверлей */
        overlay.scrollTop = 0;
      }
      function renderAll() {
        renderSlots();
        renderSizes();
        renderDeadline();
        renderTotal();
        if (isLast()) renderSummary();
        renderNav();
      }
      function goto_(i) {
        cur_ = Math.max(0, Math.min(PANES.length - 1, i));
        if (GROUPS) cur_ = scr(cur_)[0];
        showPane(); renderAll();
      }

      var lastFocus = null;

      /* The overlay is moved to <body> so no ancestor transform/overflow can trap it. */
      function ensureAtBody() {
        if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      }

      function pickDefaults() {
        var groups = overlay.querySelectorAll('[data-socd-group]');
        for (var i = 0; i < groups.length; i++) {
          var g = groups[i].getAttribute('data-socd-group');
          /* Keychain preselects the FIRST chip = "with keychain". Unlike
             "occasion" this is not a guess: the chain is listed in what the
             set includes, so with-keychain is what the customer is already
             buying. "Occasion" stays blank on purpose: guessing it would put
             invented data into the designer's brief. */
          if (g === 'channel' || g === 'keychain') {
            var first = groups[i].querySelector('.socd__chip-' + UID + '');
            if (first && !groups[i].querySelector('.is-on')) first.click();
          }
        }
        /* Preselect the STANDARD lead time, never "urgent" — the form must not
           promise urgency (and a paid express item) on the customer's behalf. */
        if (!picked.deadline) {
          picked.deadline = 'free';
          picked.deadlineLabel = L.dlStd || '';
        }
        /* Background: the designer picking it is the default we actually want —
           it is the answer that needs no thinking and no typing. */
        if (FRAME_MODE && !wiz.bg) {
          wiz.bg = 'designer';
          var bgb = overlay.querySelector('[data-socd-group2="bg"] [data-socd-val="designer"]');
          if (bgb) bgb.classList.add('is-on');
        }
        markSwatch('fcolor', wiz.fcolor);
        markSwatch('brick', wiz.brick);
        syncSlotsFromCards();
      }
      function markSwatch(group, val) {
        var box = overlay.querySelector('[data-socd-group2="' + group + '"]');
        if (!box) return;
        var bs = box.children;
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('is-on', bs[i].getAttribute('data-socd-val') === val);
      }
      /* The cards above the CTA already asked "how many" — carry that over so
         the popup never contradicts what the customer just tapped. */
      function syncSlotsFromCards() {
        if (FRAME_MODE || slotsTouched) return;
        var sel = root.querySelector('.soc2__card-' + UID + '.is-selected') ||
                  root.querySelector('[data-soc2-card][aria-checked="true"]');
        var n = sel && Number(sel.getAttribute('data-soc2-figure-count') || sel.getAttribute('data-soc2-card'));
        // Готовий образ (standalone, карток нема): кількість фігурок — з метаполя товару
        if (!n) n = Number(root.getAttribute('data-socd-qty')) || 0;
        if (!n || n < 1 || n > 12) return;
        slots = [];
        for (var i = 0; i < n; i++) slots.push('human');
      }
      var slotsTouched = false;

      overlay.addEventListener('click', function (e) {
        var chip = e.target.closest ? e.target.closest('.socd__chip-' + UID + '') : null;
        if (chip && overlay.contains(chip)) {
          var box = chip.parentNode;
          var group = box.getAttribute('data-socd-group');
          var siblings = box.querySelectorAll('.socd__chip-' + UID + '');
          for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-on');
          chip.classList.add('is-on');

          var val = chip.getAttribute('data-socd-val');
          if (group === 'keychain') {
            picked.keychain = val;
            picked.keychainLabel = chip.getAttribute('data-socd-label') || val;
          } else if (group === 'occasion') {
            /* «Інше» — не привід, а запрошення написати свій. Повторний тап
               по вже обраному чіпу знімає вибір: крок необовʼязковий. */
            if (picked.occasion === val) { picked.occasion = ''; chip.classList.remove('is-on'); }
            else picked.occasion = val;
            if (occOtherEl) {
              var showOther = picked.occasion === '__other';
              occOtherEl.style.display = showOther ? '' : 'none';
              if (showOther) setTimeout(function () { occOtherEl.focus(); }, 60);
            }
          } else if (group === 'channel') {
            picked.channel = val;
          }
          if (errEl) errEl.classList.remove('is-on');
          /* renderAll, а не renderNav: на останньому кроці під чіпами стоїть
             підсумок замовлення, і без перемальовки він показував би канал
             звʼязку, обраний за замовчуванням, а не щойно натиснутий. */
          renderAll();
          return;
        }

        /* ── wizard controls ───────────────────────────────────────────────── */
        var t = e.target;
        var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

        var rm = hit('[data-socd-slotrm]');
        if (rm && overlay.contains(rm)) {
          slots.splice(Number(rm.getAttribute('data-socd-slotrm')), 1);
          slotsTouched = true; renderAll(); return;
        }
        var set = hit('[data-socd-slotset]');
        if (set && overlay.contains(set)) {
          var parts = set.getAttribute('data-socd-slotset').split('|');
          slots[Number(parts[0])] = parts[1];
          slotsTouched = true; renderAll(); return;
        }
        if (elAddSlot && hit('[data-socd-addslot]') && !elAddSlot.hasAttribute('disabled')) {
          slots.push('human'); slotsTouched = true; renderAll(); return;
        }
        var sz = hit('[data-socd-size]');
        if (sz && overlay.contains(sz)) {
          picked.size = sz.getAttribute('data-socd-size');
          picked.sizeLabel = picked.size.replace('x', '×');
          sizeTouched = true; renderAll(); return;
        }
        var dl = hit('[data-socd-dlval]');
        if (dl && overlay.contains(dl)) {
          picked.deadline = dl.getAttribute('data-socd-dlval');
          picked.deadlineLabel = deadlineText();
          if (dateInput) {
            dateInput.style.display = (picked.deadline === 'date') ? '' : 'none';
            if (picked.deadline === 'date') setTimeout(function () { dateInput.focus(); }, 60);
          }
          renderAll(); return;
        }
        var sw = hit('[data-socd-group2] [data-socd-val]');
        if (sw && overlay.contains(sw)) {
          var grp = sw.parentNode.getAttribute('data-socd-group2');
          var v2 = sw.getAttribute('data-socd-val');
          if (grp === 'fcolor') { wiz.fcolor = v2; fcolorTouched = true; }
          else if (grp === 'brick') wiz.brick = v2;
          else if (grp === 'bg') {
            wiz.bg = v2;
            if (bgIdeaEl) {
              bgIdeaEl.style.display = (v2 === 'idea') ? '' : 'none';
              if (v2 === 'idea') setTimeout(function () { bgIdeaEl.focus(); }, 60);
            }
          }
          markSwatch(grp, v2);
          renderAll(); return;
        }
        var crumb = hit('[data-socd-goto]');
        if (crumb && overlay.contains(crumb)) { goto_(Number(crumb.getAttribute('data-socd-goto'))); return; }

        /* ⓘ «Склад ціни»: тап по значку — перемкнути, тап будь-де інде — сховати. */
        var brkBox = overlay.querySelector('[data-socd-brk]');
        if (hit('[data-socd-brk-toggle]')) {
          if (brkBox) brkBox.style.display = (brkBox.style.display === 'none') ? '' : 'none';
          return;
        }
        if (brkBox && brkBox.style.display !== 'none' && !hit('[data-socd-brk]')) {
          brkBox.style.display = 'none';
        }

        if (e.target === overlay || (e.target.closest && e.target.closest('[data-socd-close]'))) close();
      });

      /* offer_mode: підсвітити незаповнене на поточному екрані й прокрутити до першого. */
      var MISS_TXT = ({ uk: 'Заповніть позначені поля', ru: 'Заполните отмеченные поля', pl: 'Uzupełnij zaznaczone pola', en: 'Fill in the highlighted fields', it: 'Compila i campi evidenziati' })[(document.documentElement.lang || 'uk').slice(0, 2)] || 'Fill in the highlighted fields';
      function flagMissing() {
        var panesEl = overlay.querySelectorAll('[data-socd-w]'), sc = scr(cur_), bad = [];
        var mailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        sc.forEach(function (i) {
          var p = PANES[i], el = panesEl[i];
          if (!el || paneValid(p)) return;
          var mine = [];
          if (p === 'contact') {
            var hasPhone = !!el.querySelector('[data-socd-contact-phone]');
            var q = function (s) { var x = el.querySelector(s); return x && x.offsetParent !== null ? x : null; };
            var nm = q('[data-socd-contact-name]'), ph = q('[data-socd-contact-phone]'), cv = q('[data-socd-contact-val]'), em = q('[data-socd-contact-email]');
            if (nm && !nm.value.trim()) mine.push(nm);
            if (ph && ph.value.replace(/\D/g, '').length < 10) mine.push(ph);
            if (cv && !hasPhone && !cv.value.trim()) mine.push(cv);
            if (em) { var v = em.value.trim(); if (hasPhone ? (v !== '' && !mailRe.test(v)) : !mailRe.test(v)) mine.push(em); }
            var cs = el.querySelector('[data-socd-consent]');
            if (cs && !cs.checked) mine.push(cs.closest('label') || cs);
          }
          if (!mine.length) mine.push(el);
          bad = bad.concat(mine);
        });
        bad.forEach(function (b) { b.classList.remove('po-miss'); void b.offsetWidth; b.classList.add('po-miss'); });
        setTimeout(function () { bad.forEach(function (b) { b.classList.remove('po-miss'); }); }, 3000);
        if (bad[0] && bad[0].scrollIntoView) bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var msg = overlay.querySelector('[data-po-miss-msg]');
        if (!msg && nextBtn.parentNode) {
          msg = document.createElement('div'); msg.setAttribute('data-po-miss-msg', '');
          msg.style.cssText = 'width:100%;text-align:center;font-size:13px;font-weight:700;color:#dc2626;margin:0 0 6px';
          nextBtn.parentNode.parentNode.insertBefore(msg, nextBtn.parentNode);
        }
        if (msg) { msg.textContent = MISS_TXT; msg.hidden = false; clearTimeout(flagMissing._t); flagMissing._t = setTimeout(function () { msg.hidden = true; }, 3500); }
      }
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (!paneValid()) { if (GROUPS) flagMissing(); return; }
        if (isLast()) { doSubmit(); return; }
        goto_(stepTo(1));
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { goto_(stepTo(-1)); });
      if (skipBtn) skipBtn.addEventListener('click', function () { if (!isLast()) goto_(stepTo(1)); });
      if (dateInput) dateInput.addEventListener('change', function () {
        picked.deadlineLabel = deadlineText();
        renderAll();
      });
      if (bgIdeaEl) bgIdeaEl.addEventListener('input', function () { wiz.bgIdea = bgIdeaEl.value; });
      if (occOtherEl) occOtherEl.addEventListener('input', function () { wiz.occOther = occOtherEl.value; });

      function open(step) {
        ensureAtBody();
        lastFocus = document.activeElement;
        overlay.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        pickDefaults();
        /* Три API тягнемо при відкритті: ціни й наявність типів — з прайсу
           магазину, дати — з графіка складу, активні розміри рамок — з
           каталогу «⚙️ Рамки». Поки не відповіли, візард живий і показує «…»
           замість суми, а не порожній екран. */
        fetchFramePrices();
        fetchDelivery();
        fetchBgCatalog();
        fetchInventory();
        cur_ = 0;
        showPane();
        renderAll();
        showStep(step || (LAYOUT === 'choice_popup' ? 'choice' : 'brief'));
      }
      function close() {
        overlay.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (LAYOUT === 'two_buttons') {
        openBtn.addEventListener('click', function () { open('brief'); });
      } else {
        /* One button: the primary CTA opens the choice screen instead of
           navigating. Its href is still maintained by the card logic above,
           so "open the builder" keeps the ?qty=N the customer selected. */
        ctaLink.addEventListener('click', function (e) {
          e.preventDefault();
          open('choice');
        });
        /* offer_mode: «Хочу зібрати сам» — одразу в конструктор, повз розвилку,
           з тим самим ?qty=N, що й у головної кнопки. */
        var directLink = root.querySelector('[data-socd-direct]');
        if (directLink) {
          directLink.addEventListener('click', function (e) {
            e.preventDefault();
            var href = ctaLink.getAttribute('href') || directLink.getAttribute('href') || '/';
            
            setTimeout(function () { window.location.href = href; }, 150);
          });
        }
        overlay.addEventListener('click', function (e) {
          var path = e.target.closest ? e.target.closest('[data-socd-go]') : null;
          if (!path || !overlay.contains(path)) return;
          if (path.getAttribute('data-socd-go') === 'self') {
            window.location.href = ctaLink.getAttribute('href') || '/';
          } else {
            showStep('brief');
          }
        });
        overlay.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var path = e.target.closest ? e.target.closest('[data-socd-go]') : null;
          if (path) { e.preventDefault(); path.click(); }
        });
        var backBtn = overlay.querySelector('[data-socd-back]');
        if (backBtn) backBtn.addEventListener('click', function () { showStep('choice'); });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      });

      var spinEl  = overlay.querySelector('[data-socd-spin]');
      var labelEl = overlay.querySelector('[data-socd-submit-label]');
      var labelIdle = labelEl ? labelEl.textContent : '';

      /* Busy state. The variant lookup can take seconds on a cold backend —
         a dimmed button with no motion reads as "broken", so say what is
         happening and keep something moving. */
      function setBusy(on) {
        if (spinEl) spinEl.hidden = !on;
        if (labelEl) labelEl.textContent = on ? (L.submitting || labelIdle) : labelIdle;
        /* Кнопка, яку людина реально натиснула, — це «Далі/Додати в кошик»
           візарда; сам submitBtn прихований і лишився носієм налаштувань. */
        var btn = nextBtn || submitBtn;
        if (on) {
          btn.setAttribute('disabled', 'disabled');
          if (btn === nextBtn) btn.textContent = L.submitting || (L.submit || '');
        } else {
          btn.removeAttribute('disabled');
          if (btn === nextBtn) btn.textContent = L.submit || '';
        }
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      function fail() {
        if (errEl) errEl.classList.add('is-on');
        setBusy(false);
      }

      /* Короткі 502 бекенда повторюємо мовчки, людині кажемо лише як не вийшло
         ЖОДНОГО разу. Лукап ідемпотентний — ретраїти вільно; cart/add ретраїмо
         ТІЛЬКИ на мережевій/5xx (на 4xx повтор ризикує дублем позиції). */
      function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

      async function withRetry(label, attempts, fn) {
        var lastErr;
        for (var i = 0; i < attempts; i++) {
          /* Наростаючі паузи (разом ~10с на 5 спроб): свіжостворений
             variant-by-price варіант Shopify інколи віддає як «already
             sold out» довше за 2-3с — коротка драбинка не встигала
             (рамка 3662 грн, серпень 2026). */
          if (i > 0) await sleep([700, 1500, 3000, 5000][i - 1] || 5000);
          try {
            return await fn();
          } catch (e) {
            lastErr = e;
            if (e && e.__noRetry) break;
          }
        }
        var err = lastErr instanceof Error ? lastErr : new Error(String(lastErr));
        err.__stage = label;
        throw err;
      }

      /* Останній рубіж: усі спроби провалились. Склад перешле це в Telegram —
         інакше про такі збої ми дізнаємось тільки з падіння виторгу. */
      function reportFailure(err) {
        var url = submitBtn.getAttribute('data-socd-report-url');
        if (!url) return;
        try {
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,            /* щоб долетіло, навіть якщо сторінку закриють */
            body: JSON.stringify({
              stage: (err && err.__stage) || 'unknown',
              store: submitBtn.getAttribute('data-socd-store') || '',
              message: String((err && err.message) || err || '').slice(0, 300),
              url: location.href.slice(0, 300)
            })
          }).catch(function () { /* репорт — best effort, покупцю це не показуємо */ });
        } catch (e) { /* ignore */ }
      }

      /* Який варіант продавати: 1) явний per-card variant ID; 2) інакше
         find-or-create за ЦІНОЮ картки (той самий ендпоінт конструктора);
         3) фолбек на варіант товару лише без ціни взагалі. Невдалий лукап =
         помилка, не фолбек: тиха неправильна ціна гірша за відмову. */
      function variantForPrice(price, productType) {
        var api = submitBtn.getAttribute('data-socd-variant-api');
        if (!api || !(price > 0)) return Promise.reject(new Error('no price, no variant'));
        return withRetry('variant', 3, function () {
          return fetch(api, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ price: price, productType: productType })
          })
            .then(function (r) {
              if (r.ok) return r.json();
              /* Бекенд кладе причину в body.error — тягнемо її в алерт. */
              return r.json().catch(function () { return {}; }).then(function (b) {
                var detail = b && (b.error || b.message);
                return Promise.reject(new Error('HTTP ' + r.status + (detail ? ' — ' + String(detail).slice(0, 180) : '')));
              });
            })
            .then(function (d) {
              var gid = d && d.variant && d.variant.id;
              if (!d.success || !gid) return Promise.reject(new Error('no variant'));
              return Number(String(gid).split('/').pop());
            });
        });
      }

      /* Frame — ONE line (size+figures → one variant). Set — ONE LINE PER TYPE
         (qty=count), як бандл конструктора, інакше автоматична знижка Shopify
         не спрацює (2 людини + 1 звір = 2×figure + 1×animal, не 3×figure).
         Бриф — ТІЛЬКИ на першій лінії (дубль = склад бачить замовлення
         кілька разів); решта несуть _bt_designer для виключення списання. */
      function cartLines(props) {
        if (FRAME_MODE) {
          var ft = totals().total;
          if (!(ft > 0)) return Promise.reject(new Error('frame price unavailable'));
          if (picked.variant) return Promise.resolve([{ id: Number(picked.variant), quantity: 1, properties: props }]);
          return variantForPrice(ft, submitBtn.getAttribute('data-socd-product-type') || 'frame')
            .then(function (id) { return [{ id: id, quantity: 1, properties: props }]; });
        }

        var counts = {}, order = [], i;
        for (i = 0; i < slots.length; i++) {
          if (!counts[slots[i]]) { counts[slots[i]] = 0; order.push(slots[i]); }
          counts[slots[i]]++;
        }
        /* Прайс не відповів — відкочуємось на ціну картки й одну позицію:
           замовлення пройде за рекламованою сумою, покупець не втратить. */
        if (!framePrices) {
          var priceTxt = picked.price || submitBtn.getAttribute('data-socd-price') || '';
          var p = parsePriceText(priceTxt);
          if (!(p > 0)) {
            var fb = submitBtn.getAttribute('data-socd-variant');
            if (!fb) return Promise.reject(new Error('no price, no variant'));
            return Promise.resolve([{ id: Number(fb), quantity: 1, properties: props }]);
          }
          return variantForPrice(p, submitBtn.getAttribute('data-socd-product-type') || 'mini')
            .then(function (id) { return [{ id: id, quantity: 1, properties: props }]; });
        }

        var ptype = submitBtn.getAttribute('data-socd-product-type') || 'mini';
        var jobs = order.map(function (t) {
          var price = typePrice(t);
          if (!(price > 0)) return Promise.reject(new Error('no price for ' + t));
          /* Тваринка — окремий тип товару в бекенді, у неї свій прайс і свій SKU. */
          return variantForPrice(price, t === 'animal' ? 'pet' : ptype)
            .then(function (id) { return { id: id, quantity: counts[t], type: t }; });
        });
        return Promise.all(jobs).then(function (lines) {
          var thin = {};
          thin['_bt_designer'] = '1';
          var img = submitBtn.getAttribute('data-socd-cart-img');
          if (img) thin['_bt_designer_img'] = img;
          thin[L.mode || 'Design'] = L.modeVal || 'Designer';
          return lines.map(function (l, idx) {
            return { id: l.id, quantity: l.quantity, properties: idx === 0 ? props : thin };
          });
        });
      }

      function doSubmit() {
        /* «Оплата після макета»: заявку шле асет bt-design-request.js. */
        if (REQUEST_MODE) {
          if (window.BTDesignRequest) { window.BTDesignRequest.submit(REQX); } else { fail(); }
          return;
        }
        /* Крокова валідація вже не пускає далі без розміру/дедлайну, але
           лишаємо і тут: кнопку можна дістати програмно. */
        if (FRAME_MODE && !activeSize()) return;
        if (!picked.deadline) return;

        var composition = {}, i;
        for (i = 0; i < slots.length; i++) composition[slots[i]] = (composition[slots[i]] || 0) + 1;

        var props = {};
        props['_bt_designer'] = '1';
        /* Hidden: the cart snippet swaps the line thumbnail to this when present.
           A price-matched variant carries the generic product photo, which gives
           the customer no clue that a designer is building this one. */
        var cartImg = submitBtn.getAttribute('data-socd-cart-img');
        if (cartImg) props['_bt_designer_img'] = cartImg;
        props[L.mode || 'Design'] = L.modeVal || 'Designer';
        /* Склад друкує це як «Кількість фігурок: 2 × Людина, 1 × Тваринка» —
           дизайнеру одразу видно склад набору, а не саме лише число. */
        props[L.qty || 'Qty'] = composeText();
        /* Printed as "Тип: Брелок" / "Тип: Без брелока" — the same shape the
           constructor writes, so the cart's keychain counter reads designer
           lines too instead of ignoring them. */
        if (picked.keychainLabel) props[L.keychain || 'Type'] = picked.keychainLabel;
        if (FRAME_MODE) {
          props[L.figs || 'Figures'] = String(slots.length);
          if (activeSize()) props[L.size || 'Size'] = activeSize().replace('x', '×');
          props[L.propFcolor || 'Frame colour'] = swLabel('fcolor', wiz.fcolor);
          props[L.propBrick || 'Brick colour'] = swLabel('brick', wiz.brick);
          if (bgText()) props[L.propBg || 'Background'] = bgText();
          if (signEl && signEl.value.trim()) props[L.propSign || 'Caption'] = signEl.value.trim().slice(0, 200);
        }
        props[L.deadline || 'Deadline'] = deadlineText();
        if (occText()) props[L.occasion || 'Occasion'] = occText();
        if (wishesEl && wishesEl.value.trim()) props[L.wishes || 'Wishes'] = wishesEl.value.trim().slice(0, 900);
        if (picked.channel) props[L.channel || 'Contact'] = picked.channel;

        /* Stable machine-readable copy for the warehouse / Orders 2.0.
           ⚠⚠ Кожне НОВЕ поле треба покласти в ОБИДВА парсери, інакше воно
           мовчки зникне: sklad lib/order-sources.ts (normalizeDesignerBrief)
           і kickflip core/orders_v2_utils.py (_extract_designer_brief). */
        props['_bt_designer_brief'] = JSON.stringify({
          qty: String(slots.length),
          composition: composition,
          figures: FRAME_MODE ? String(slots.length) : null,
          size: FRAME_MODE ? activeSize() : null,
          frame_color: FRAME_MODE ? wiz.fcolor : null,
          brick_color: FRAME_MODE ? wiz.brick : null,
          background: FRAME_MODE ? (bgText() || null) : null,
          signature: (FRAME_MODE && signEl && signEl.value.trim().slice(0, 200)) || '',
          deadline: picked.deadline,
          keychain: picked.keychain ? picked.keychain === 'yes' : null,
          deadline_date: (dateInput && dateInput.value) || '',
          occasion: occText(), channel: picked.channel,
          wishes: (wishesEl && wishesEl.value.trim().slice(0, 900)) || ''
        });

        setBusy(true);
        if (errEl) errEl.classList.remove('is-on');

        cartLines(props)
          .then(function (items) {
            return withRetry('cart', 5, function () {
              return fetch(submitBtn.getAttribute('data-socd-add-url') || '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: items })
              }).then(function (r) {
                if (r.ok) return r.json();
                /* Тіло відповіді каже, ЧОМУ Shopify відмовив («Cannot find
                   variant», «sold out») — без нього в алерті голий статус,
                   який неможливо діагностувати. Читаємо best-effort. */
                return r.json().catch(function () { return {}; }).then(function (b) {
                  var detail = b && (b.description || b.message);
                  var e = new Error('HTTP ' + r.status + (detail ? ' — ' + String(detail).slice(0, 180) : ''));
                  /* 4xx — Shopify нас зрозумів і відмовив: повтор дасть те саме.
                     Виняток — 422: свіжостворений variant-by-price варіант перші
                     секунди невідомий вітрині, і повтор із паузою проходить.
                     Дубля не буде — чистий 422 означає, що в кошик нічого не впало
                     (ризик дубля існує лише на таймауті/5xx). */
                  if (r.status < 500 && r.status !== 422) e.__noRetry = true;
                  return Promise.reject(e);
                });
              });
            });
          })
          .then(function () {
            window.location.href = submitBtn.getAttribute('data-socd-cart-url') || '/cart';
          })
          .catch(function (err) {
            reportFailure(err);
            fail();
          });
      }
      submitBtn.addEventListener('click', doSubmit);
    })();

  })();

  }
  window.BtSocdInit = init;
  var q = window.BtSocdQueue || [];
  window.BtSocdQueue = { push: function (a) { init(a[0], a[1]); } };
  for (var i = 0; i < q.length; i++) init(q[i][0], q[i][1]);
})();
